import React from "react";
import Drawer, { DrawerProps } from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import { ChatRoomList } from "components/chat-room/chat-room-list";

const drawerWidth = 240;

type NavDrawerProps = DrawerProps;

export const NavDrawer: React.FC<NavDrawerProps> = (props) => (
  <Drawer
    {...props}
    variant="temporary"
    slotProps={{
      paper: { sx: { width: drawerWidth } },
    }}
    sx={{ width: drawerWidth }}
  >
    <Toolbar />
    <ChatRoomList />
  </Drawer>
);
